import React, { useRef, useState } from "react";
import { Grid, Stack, Typography } from "@mui/material";

import { Select, Input, InputNumber } from "../../components/Common";
import InputEmail from "../../components/Common/InputFieldEmail";
import InputMobileNumber from "../../components/Common/InputFieldMobileNumber";

import { trakrefFontFamilySemiBold } from "../../utils";
import { TranslateW } from "../../Utils/Languages/Translate";
import useFileUpload from "../../hooks/useFileUpload";

import UserInfo from "../../UserInfo";
import Routes from "../../routes";

import "./Profile.css";

const EditProfiledetails = ({
    userInfo,
    onHandleValueChanged,
    options,
    isFieldValid,
    setErrorExist,
    uniqueFieldState = {},
}) => {
    const [profileImage, setProfileImage] = useState(userInfo.headshot);
    const fileInputRef = useRef();

    const { readFileDataAsBase64 } = useFileUpload();

    const onUploadFileClick = () => {
        fileInputRef.current.click();
    };

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        const byteFile = await readFileDataAsBase64(file);

        let formData = new FormData();
        formData.append("fileTypeId", 8);
        formData.append("fileName", file.name);
        formData.append("contentType", file.type);
        formData.append("fileBytes", byteFile);

        const response = await fetch(Routes.File.UploadUserFile(), {
            method: "POST",
            body: formData,
        });

        if (response.status !== 200) return;

        const res = response.json();
        setProfileImage(URL.createObjectURL(file));
    };

    return (
        <>
            <div className="editprofile-header-container">
                {userInfo.headshot ? (
                    <img className="greenImageLarge" src={profileImage} />
                ) : (
                    <div className="greenCircleLarge">{userInfo.shortName}</div>
                )}
                <div>
                    <Typography
                        variant="h5"
                        sx={{
                            "&.MuiTypography-root": {
                                fontFamily: trakrefFontFamilySemiBold,
                                fontSize: "16px",
                            },
                        }}
                        style={{ color: "#333333" }}
                    >
                        {userInfo.name}
                    </Typography>
                    <span className="update-image-label" onClick={onUploadFileClick}>
                        {TranslateW("Profile.UploadProfilePicture")}
                    </span>
                    <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: "none " }}
                        onChange={onFileChange}
                        accept="image/png, image/gif, image/jpeg"
                    />
                </div>
            </div>

            <Grid container spacing={6}>
                <Grid item xs={6} md={6}>
                    <p className="inputfields-header-label">
                        {TranslateW("Profile.GeneralInformation")}
                    </p>
                    <Stack spacing={3}>
                        {!UserInfo.IsWriteIntech && (
                            <Input
                                required
                                fullWidth
                                value={userInfo.userName}
                                label={TranslateW("Profile.Username")}
                                error={isFieldValid(userInfo.userName)}
                                disabled={!UserInfo.isSystemAdministrator()}
                                onChange={(e) =>
                                    onHandleValueChanged("userName", e.target.value)
                                }
                            />
                        )}
                        <Input
                            required
                            fullWidth
                            value={userInfo.firstName}
                            label={TranslateW("Profile.Firstname")}
                            error={isFieldValid(userInfo.firstName)}
                            onChange={(e) =>
                                onHandleValueChanged("firstName", e.target.value)
                            }
                        />
                        <Input
                            required
                            fullWidth
                            value={userInfo.lastName}
                            error={isFieldValid(userInfo.lastName)}
                            label={TranslateW("Profile.Lastname")}
                            onChange={(e) => onHandleValueChanged("lastName", e.target.value)}
                        />
                        <Select
                            value={userInfo.fkid}
                            label={TranslateW("Profile.ContractorDesignation")}
                            options={options.company}
                            onChange={(e) => onHandleValueChanged("fkid", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.description}
                            label={TranslateW("Profile.Description")}
                            onChange={(e) =>
                                onHandleValueChanged("description", e.target.value)
                            }
                        />
                        <Input
                            fullWidth
                            value={userInfo.fax}
                            label={TranslateW("Profile.Fax")}
                            onChange={(e) =>
                                onHandleValueChanged("fax", e.target.value)
                            }
                        />
                    </Stack>
                </Grid>
                <Grid item xs={6} md={6}>
                    <p className="inputfields-header-label">
                        {TranslateW("Profile.ContactDetails")}
                    </p>
                    <Stack spacing={3}>
                        {!UserInfo.IsWriteIntech && (
                            <InputEmail
                                required
                                fullWidth
                                value={userInfo.email}
                                error={isFieldValid(userInfo.email) || !!uniqueFieldState.email}
                                helperText={uniqueFieldState.email || "This field is required"}
                                label={TranslateW("Profile.EmailAddress")}
                                onChange={(e) => onHandleValueChanged("email", e.target.value)}
                            />
                        )}
                        <InputMobileNumber
                            fullWidth
                            value={userInfo.cell}
                            label={TranslateW("Profile.MobileNumber")}
                            onChange={(e) => onHandleValueChanged("cell", e.target.value)}
                            getCountryCode={(value) => onHandleValueChanged("countryCode", value)}
                            isValid={(error) => setErrorExist(error)}
                        />
                        <InputMobileNumber
                            fullWidth
                            value={userInfo.phone}
                            label={TranslateW("Profile.PhoneNumber")}
                            onChange={(e) => onHandleValueChanged("phone", e.target.value)}
                            getCountryCode={(value) => onHandleValueChanged("countryCode2", value)}
                            isValid={(error) => setErrorExist(error)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.title}
                            label={TranslateW("Profile.Title")}
                            onChange={(e) => onHandleValueChanged("title", e.target.value)}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={6} md={6}>
                    <p className="inputfields-header-label">
                        {TranslateW("Profile.Address")}
                    </p>
                    <Stack spacing={3}>
                        <Input
                            fullWidth
                            value={userInfo.address1}
                            label={TranslateW("Profile.Address1")}
                            onChange={(e) => onHandleValueChanged("address1", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.address2}
                            label={TranslateW("Profile.Address2")}
                            onChange={(e) => onHandleValueChanged("address2", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.city}
                            label={TranslateW("Profile.City")}
                            onChange={(e) => onHandleValueChanged("city", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.county}
                            label={TranslateW("Profile.County")}
                            onChange={(e) => onHandleValueChanged("county", e.target.value)}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Stack spacing={3} sx={{ marginTop: "30px" }}>
                        <InputNumber
                            fullWidth
                            hideStepper={true}
                            value={userInfo.zip}
                            label={TranslateW("Profile.ZipCode")}
                            onChange={(e) => onHandleValueChanged("zip", e.target.value)}
                        />
                        <Select
                            required
                            value={userInfo.state}
                            error={isFieldValid(userInfo.state)}
                            label={TranslateW("Profile.StateProvince")}
                            options={options.state}
                            onChange={(e) => onHandleValueChanged("state", e.target.value)}
                        />
                        <Select
                            required
                            value={userInfo.country}
                            error={isFieldValid(userInfo.country)}
                            label={TranslateW("Profile.Country")}
                            options={options.country}
                            onChange={(e) => onHandleValueChanged("country", e.target.value)}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default EditProfiledetails;
